import React, { useState } from 'react';
import { LanguageProvider } from './contexts/LanguageContext';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { About } from './components/About';
import { Services } from './components/Services';
import { Testimonials } from './components/Testimonials';
import { Contact } from './components/Contact';
import { Footer } from './components/Footer';
import { PrivacyPolicy } from './components/PrivacyPolicy';
import { TermsOfService } from './components/TermsOfService';
type Page = 'home' | 'privacy' | 'terms';
export function App() {
  const [currentPage, setCurrentPage] = useState<Page>('home');
  const handleNavigate = (page: Page) => {
    setCurrentPage(page);
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };
  return <LanguageProvider data-id="element-0">
      <div className="min-h-screen bg-brand-dark text-white font-sans selection:bg-brand-accent selection:text-brand-dark" data-id="element-1">
        <Navbar data-id="element-2" />

        {currentPage === 'home' && <>
            <main data-id="element-3">
              <Hero data-id="element-4" />
              <About data-id="element-5" />
              <Services data-id="element-6" />
              <Testimonials data-id="element-7" />
              <Contact data-id="element-8" />
            </main>
            <Footer onNavigate={handleNavigate} data-id="element-9" />
          </>}

        {currentPage === 'privacy' && <>
            <PrivacyPolicy onBack={() => handleNavigate('home')} data-id="element-10" />
            <Footer onNavigate={handleNavigate} data-id="element-11" />
          </>}

        {currentPage === 'terms' && <>
            <TermsOfService onBack={() => handleNavigate('home')} data-id="element-12" />
            <Footer onNavigate={handleNavigate} data-id="element-13" />
          </>}
      </div>
    </LanguageProvider>;
}